/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-27 16:20:41
 * @LastEditors: K
 * @LastEditTime: 2022-08-30 17:45:12
 */
import { TableColumnType, Tag } from 'antd';
import React from 'react';
import styles from "./labelManagementPage.module.css";

export const Columns = (
  onClick: (t: any) => void,
  startIndex: number,
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },

    {
      title: '标签名称',
      dataIndex: 'name',
      align: 'center',
    },
    {
      title: '标签颜色',
      dataIndex: 'fontColor',
      align: 'center',
      render: function element(_, t) {
        return (
          <Tag
            className={styles.icon}
            color={t.backgroundColor}
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              border: "none",
            }}
          >
            <a
              style={{
                lineHeight: "30px",
                textAlign: "center",
                width: "30px",
                height: "30px",
                color: t.fontColor,
              }}
            >
              {t.headName}
            </a>
          </Tag>
        );
      },
    },

    {
      title: '操作',
      dataIndex: 'tenantCategory4',
      align: 'center',
      render: function tenantCategory(_, t) {
        return (
          <a onClick={() => onClick(t)}>编辑 </a>
        )
      },
    },

  ]
}

